import React, { useState } from "react";
import {
    Button,
    StandardModal,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalSection
} from "src/components";

const DeleteDialog = ({ closeDeleteDialog, onConfirm }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = (e) => {
        setIsDeleting(true);
        onConfirm(e);
    };
    return (
        <StandardModal
            open={true}
            onClose={closeDeleteDialog}
            title="Delete Selected Directory Contact"
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        onClick={closeDeleteDialog}
                        size="0.875rem"
                        border="1px solid #000"
                        color="#000"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelete}
                        size="0.875rem"
                        backgroundColor="#ff7171"
                        border="1px solid #ff7171"
                        color="#fff"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none", opacity: `${isDeleting && "0.6"}` }}
                        disabled={isDeleting}
                    >
                        {isDeleting ? "Deleting..." : "Delete" }
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalDescription style={{ textAlign: "center", maxWidth: "100%" }}>
                    Are you sure you want to delete the selected Directory contact or <br /> contacts from this list?
                </StandardModalDescription>
            </StandardModalSection>
        </StandardModal>
    );
};

export default DeleteDialog;
